import React, {
  Fragment, useContext, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import useFetch from '../../../../services/useFetch';
import TextField from '../../../../components/TextField';
import Button from '../../../../components/Button';
import BackButton from '../../../../components/BackButton';
import Form from '../../../../components/Form';
import Title from '../../../../components/Title';
import Loader from '../../../../components/Loader';
import validate from './validation';
import { DispatchDialogContext } from '../../../../providers/DialogProvider/DialogContext';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};

const fetchConfig = {
  initalMethod: 'post',
  initialUri: '/api/v1/healt_clinic/upsert',
  showSuccessMessage: false,
  showErrorMessage: false,
};

function EditFiles({ match }) {
  const { params } = match;
  const { id } = params;
  const initialForm = {
    id_health_clinic: id,
    method: 'update',
    description: '',
  };
  const dialog = useContext(DispatchDialogContext);
  const fetch = useFetch(fetchConfig);
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const title = `Editar Archivo: ${form.description}`;
  const fileRefs = {
    excel: React.useRef(null),
  };

  async function getFormData() {
    const config = {
      method: 'get',
      uri: `/api/v1/communication_campaign/edit/${id}`,
    };
    setLoading(true);
    const response = await fetch.fetch({}, config);
    setForm({ ...initialForm, method: 'update', ...response.data });
    setLoading(false);
  }

  useEffect(() => {
    getFormData();
  }, []);

  function handleFileChange(ref) {
    return () => {
      if (fileRefs[ref].current.files[0]) {
        setForm({ ...form, [ref]: fileRefs[ref].current.files[0] });
      } else {
        setForm({ ...form, [ref]: null });
      }
    };
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setErrors({});
    const result = await validate(form);
    setErrors(result.errors);

    if (!result.isValid) {
      dialog({
        type: 'error',
        content: 'El formulario presenta errores.',
      });
      return;
    }

    const config = {
      method: 'post',
      uri: '/api/v1/healt_clinic/upsert',
    };
    const response = await fetch.fetch(form, config);
    dialog({
      type: response.success ? 'success' : 'error',
      content: response.message,
    });
    if (response.success) {
      getFormData();
    }
  }

  return (
    <Fragment>
      <BackButton />
      <Form
        xs={12}
        onSubmit={handleSubmit}
      >
        <Title variant="h5" component="h2">{title}</Title>

        <TextField
          type="file"
          name="excel"
          label="Excel de usuarios"
          onChange={handleFileChange('excel')}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            ref: fileRefs.excel,
            accept: '.xlsx',
          }}
          error={!!errors.excel}
          helperText={errors.excel}
        />

        <Button type="submit" color="primary" disabled={fetch.isLoading} square>Guardar</Button>
      </Form>
    </Fragment>
  );

  // return loading
  //   ? <Loader />
  //   : (
  //     <Fragment>
  //       <BackButton />
  //       <Form
  //         xs={12}
  //         onSubmit={handleSubmit}
  //       >
  //         <Title variant="h5" component="h2">{title}</Title>

  //         <TextField
  //           type="text"
  //           name="address"
  //           label="Dirección"
  //           value={form.address || ''}
  //           onChange={handleInputChange}
  //           error={!!errors.address}
  //           helperText={errors.address}
  //         />

  //         <TextField
  //           type="text"
  //           name="phone"
  //           label="Teléfono"
  //           value={form.phone || ''}
  //           onChange={handleInputChange}
  //           error={!!errors.phone}
  //           helperText={errors.phone}
  //         />

  //         <TextField
  //           type="text"
  //           name="webpage"
  //           label="Página web"
  //           value={form.webpage || ''}
  //           onChange={handleInputChange}
  //           error={!!errors.webpage}
  //           helperText={errors.webpage}
  //         />

  //         <Button type="submit" color="primary" disabled={fetch.isLoading} square>Guardar</Button>
  //       </Form>
  //     </Fragment>
  //   );
}

EditFiles.propTypes = propTypes;

export default EditFiles;
